import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  hidden?: boolean;
}

const HiddenSpace = ({ children, hidden }: Props) => {
  if (hidden) return null;

  return <>{children}</>;
};

export default HiddenSpace;
